import type { IMaintenanceType } from '@/interfaces'
import Base from '../Base'
import type { AssetType } from '@/enum'
import type { IValueAndUnit } from '@/interfaces/IValueAndUnit'

class MaintenanceType extends Base implements IMaintenanceType {
  title: string

  description: string

  assetType: AssetType

  workHours: number

  constructor(maintenanceType?: any) {
    super(maintenanceType)
    this.title = maintenanceType?.title
    this.description = maintenanceType?.description
    this.assetType = maintenanceType?.assetType
    this.workHours = maintenanceType?.workHours
  }
}

export default MaintenanceType
